import { useControlled } from "@commonlibs";
import clsx from "clsx";
import InnerCardNavigation from "../../layout/CardNavigation/InnerCardNavigation/InnerCardNavigation";
import CardModal from "../CardModal/CardModal";
import { CardNavigationModalProps } from "./CardNavigationModal.types";

function CardNavigationModal({
    className,
    divider,
    defaultOpen,
    closable = true,
    header: { left: leftProp, onLeftClick, ...headerProps },
    animation = "from-bottom",
    transitionsDuration = { enter: 301, exit: 200 },
    open: openProp,
    onClose,
    children,
    ...rest
}: CardNavigationModalProps) {
    //hooks
    const [open, setOpen] = useControlled(defaultOpen, openProp, onClose);

    //handlers
    function handleCloseModal() {
        if (!closable) return;
        setOpen(false);
        onClose?.();
    }
    function handleLeftClick() {
        if (leftProp === "close-modal") handleCloseModal();
        onLeftClick?.();
    }

    //constants
    const left = leftProp === "close-modal" ? "close" : leftProp;

    return (
        <CardModal
            className={clsx("card-navigation-modal", className)}
            open={open}
            onClose={handleCloseModal}
            closable={closable}
            animation={animation}
            transitionsDuration={transitionsDuration}
            {...rest}
        >
            <InnerCardNavigation header={{ left, onLeftClick: handleLeftClick, ...headerProps }} divider={divider}>
                {children}
            </InnerCardNavigation>
        </CardModal>
    );
}

export default CardNavigationModal;
